module.exports = __webpack_public_path__ + "static/Stracciatella-d53825b1ba1f76943f743e8a8ffd9d61.png";